<template>
  <div class="fj-dateranger py-0.5 px-2" :class="{ empty: !dateSelected }">
    <button class="flex items-center gap-1" @click="openRanger">
      <span v-if="isRange">{{ !dateSelected ? 'Start date - End date' : dateSelected }}</span>
      <span v-if="!isRange">{{ !dateSelected ? 'Start date' : dateSelected }}</span>
      <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 0.5L5 5L9.5 0.5" stroke="#606266" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
    <el-date-picker
      ref="dateRange"
      v-model="rangeDate"
      :type="isRange ? 'daterange' : 'date'"
      start-placeholder="Start Date"
      end-placeholder="End Date"
      format="d MMMM yyyy"
    >
    </el-date-picker>
  </div>
</template>
<script>
import dayjs from 'dayjs'

export default {
  props: {
    value: {
      type: [String, Array, Date],
      default: '',
    },
    isRange: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rangeDate: this.value,
    }
  },
  computed: {
    dateSelected() {
      return this.formatDatePeriod(this.rangeDate)
    },
  },
  watch: {
    rangeDate(value) {
      this.$emit('input', value)
    },
  },
  methods: {
    openRanger(event) {
      const ElRanger = this.$refs.dateRange
      const mouseX = event.clientX
      const mouseY = event.clientY
      ElRanger.showPicker()
      // const popperElm = ElRanger.popperElm

      // setTimeout(() => {
      //   popperElm.style.left = `-${event.clientX}px`
      //   popperElm.style.top = `${event.clientY}px`
      // }, 0)
    },
    formatDatePeriod(period) {
      if (!period || (Array.isArray(period) && period?.length === 0)) {
        return false
      }

      if (!this.isRange) {
        const startDate = dayjs(period)
        const startDay = startDate.date()
        const startMonth = startDate.format('MMM')
        const startYear = startDate.year()
        return `${startDay} ${startMonth} ${startYear}`
      }

      const startDate = dayjs(period[0])
      const endDate = dayjs(period[1])

      const startDay = startDate.date()
      const startMonth = startDate.format('MMM')
      const endDay = endDate.date()
      const endMonth = endDate.format('MMM')

      const startYear = startDate.year()
      const endYear = endDate.year()

      if (startYear === endYear) {
        return `${startDay} ${startMonth} - ${endDay} ${endMonth}, ${startYear}`
      } else {
        return `${startDay} ${startMonth} ${startYear} - ${endDay} ${endMonth} ${endYear}`
      }
    },
  },
}
</script>
<style lang="scss">
.fj-dateranger {
  @apply relative;
  &.empty {
    @apply text-gray;
  }
  &:hover {
    @apply text-primary;
  }
  .el-date-editor {
    opacity: 0;
    pointer-events: none;
    width: 1px;
    height: 1px;
    position: absolute;
  }
}
</style>
